// PrivacyPage.js
import React from "react";

function PrivacyPage() {
  return (
    <div className="container mt-5">
      <h2 className="mb-4">นโยบายความเป็นส่วนตัว (Privacy Policy)</h2>
      <p>
        KSN2018 ให้ความสำคัญกับความเป็นส่วนตัวของผู้ใช้ และเก็บข้อมูลเท่าที่จำเป็นสำหรับการให้บริการเท่านั้น
      </p>
      <ul>
        <li>เราจะไม่เปิดเผยข้อมูลของท่านแก่บุคคลภายนอก ยกเว้นกรณีตามที่กฎหมายกำหนด</li>
        <li>ข้อมูลที่เก็บ เช่น ชื่อผู้ใช้งาน รหัสผ่าน หมายเลขอุปกรณ์ จะใช้เพื่อการให้บริการภายในระบบเท่านั้น</li>
        <li>ท่านสามารถติดต่อขอแก้ไข หรือลบข้อมูลของท่านได้ทุกเมื่อ</li>
      </ul>
    </div>
  );
}

export default PrivacyPage;